// Vue
import { Vue, Component, Prop, Inject } from "vue-property-decorator";

// Template
import template from "./template.vue";

import ModuleWrapper from "#/components/module_wrapper/ModuleWrapper";

import ModuleBase from "#/common/ModuleBase";

@Component({
  mixins: [template],
  components: {
    ModuleWrapper,
  },
})
export class ContentAdvantageModule extends ModuleBase {
  private accordionOpenStatus: boolean[] = [];

  private parallaxSpeed = 0.2;
  private parallaxNodes: any = null;
  private parallaxNodeOffsetTop = 0;
  private parallaxHeightMethod: any = null;

  public mounted() {
    window.addEventListener("resize", this.initParallax);
    window.addEventListener("scroll", this.doParallax);
    this.initParallax();
  }

  public initParallax() {
    if (window.outerWidth >= 1024) {
      this.parallaxNodes = document.querySelectorAll(
        `.${APP_PREFIX}-content-advantage-module`
      );
      for (let i = 0; i < this.parallaxNodes.length; i++) {
        this.parallaxNodeOffsetTop = this.parallaxNodes[i].offsetTop;
      }
      this.parallaxHeightMethod = function (e) {
        return e.offsetHeight;
      };
    }

    this.doParallax();
  }

  public doParallax() {
    if (!this.parallaxNodes || !this.parallaxNodes.length) return false;

    let s = this.getWindowScrollTop();
    let n = window.outerHeight;
    let leftOffset = this.parallaxNodes[0].getBoundingClientRect().left;

    for (let i = 0; i < this.parallaxNodes.length; i++) {
      let t = this.parallaxNodes[i];
      let f = t.offsetTop;
      let l = t.outerHeight;
      if (f + l < s || f > s + n) return;

      for (let o = 0; o < this.parallaxNodes.length; o++) {
        let pn = this.parallaxNodes[o];
        pn.style.backgroundPosition =
          leftOffset +
          "px " +
          Math.round((this.parallaxNodeOffsetTop - s) * this.parallaxSpeed) +
          "px";
      }
    }
  }

  public getWindowScrollTop() {
    var supportPageOffset = window.pageXOffset !== undefined;
    var isCSS1Compat = (document.compatMode || "") === "CSS1Compat";
    return supportPageOffset
      ? window.pageYOffset
      : isCSS1Compat
      ? document.documentElement.scrollTop
      : document.body.scrollTop;
  }

  public getBackgroundColorFromInstance(instance: object) {
    return "black";
  }

  public toggle(index) {
    let current = this.accordionOpenStatus[index];
    this.accordionOpenStatus = [];

    this.instance["advantages"].forEach(() => {
      this.accordionOpenStatus.push(false);
    });

    this.accordionOpenStatus[index] = !current;
  }

  public accordionIsOpen(index) {
    if (this.accordionOpenStatus.length > index) {
      return this.accordionOpenStatus[index];
    } else {
      return false;
    }
  }

  public accordionActiveState(index) {
    if (this.accordionOpenStatus[index] == true) {
      return "active";
    } else {
      return "";
    }
  }
}
